import React from 'react';

import LazyImage from 'gui/components/LazyImage/LazyImage';
import HowItWorksPoints from '../../../guarantees/components/howItWorksPoints/HowItWorksPoints';

interface ISellerPointsProps {
  className?: string;
}

const SellerPoints = (props: ISellerPointsProps) => (
  <HowItWorksPoints
    pointIcon={<LazyImage src={'/img/guranteeSellerOk.png'} title={'point'}/>}
    points={[
      'פרסמו מודעה',
      'קבלו בקשה לרכישה ואשרו את העסקה',
      'תשלום יועבר ע"י הקונה ל deal&go',
      'העלו את השובר / כרטיס המעודכנים לאתר',
      'לאחר 10 ימים התשלום יועבר לחשבונכם',
    ]}
    {...props}
  />
);


SellerPoints.defaultProps = {
  className: undefined,
};

export default React.memo(SellerPoints);
